import { useMutation } from '@tanstack/react-query';
import { vacancyApi } from '../vacancyApi';
import { MutationKey } from '@shared/config';

export const useExportVacancy = () => {
  return useMutation({
    mutationKey: [MutationKey.EXPORT_VACANCY],
    mutationFn: async ({
      dateFrom,
      dateTo,
    }: {
      dateFrom: string | null;
      dateTo?: string | null;
    }) => {
      const response = vacancyApi.exportVacancy({ dateFrom, dateTo });
      return response;
    },
  });
};
